import React from 'react';
import { Belt } from './types';

interface BeltStripesProps {
  belts: Belt[];
  onStripeClick?: (belt: Belt) => void;
}

export const BeltStripes: React.FC<BeltStripesProps> = ({ belts, onStripeClick }) => {
  const renderStripesBetweenBelts = () => {
    return belts.map((belt, index) => {
      if (index >= belts.length - 1) return null;

      const startX = 40;
      const beltSpacing = 230;
      const beltLeftPos = startX + (index * beltSpacing);
      const beltRightPos = startX + ((index + 1) * beltSpacing);

      const stripePadding = 45;
      const startPos = beltLeftPos + stripePadding;
      const endPos = beltRightPos - stripePadding;
      const stripeAreaWidth = endPos - startPos;

      const stripeCount = 4;
      const gapSize = stripeAreaWidth / (stripeCount + 1);

      return Array.from({ length: stripeCount }).map((_, i) => {
        const stripePosition = startPos + gapSize * (i + 1);
        
        // Create a belt object for this stripe
        const stripeBelt: Belt = {
          name: `${belt.name} belt ${i + 1} stripe${i === 0 ? '' : 's'}`,
          color: belt.color,
          dbColor: belt.dbColor,
          stripes: i + 1,
          isStripe: true
        };

        return (
          <div 
            key={`stripe-${index}-${i}`}
            className="absolute transform -translate-x-1/2 z-10 cursor-pointer hover:scale-110 hover:brightness-95 transition-all"
            style={{ 
              left: stripePosition, 
              top: '50%',
              transform: 'translate(-50%, -50%)',
              height: '56px',
              width: '16px',
              backgroundColor: 'white',
              border: '2px solid black',
              borderRadius: '4px'
            }}
            onClick={() => onStripeClick && onStripeClick(stripeBelt)}
            role="button"
            tabIndex={0}
            aria-label={`${belt.name} belt ${i + 1} stripe${i === 0 ? '' : 's'}`}
          />
        );
      });
    });
  };

  const renderStripesAfterBlackBelt = () => {
    const startX = 40;
    const beltSpacing = 230;
    const blackBeltPosition = startX + (4 * beltSpacing);
    const arrowPosition = blackBeltPosition + beltSpacing;

    const stripePadding = 45;
    const startPos = blackBeltPosition + stripePadding;
    const endPos = arrowPosition - stripePadding;
    const stripeAreaWidth = endPos - startPos;

    const stripeCount = 4;
    const gapSize = stripeAreaWidth / (stripeCount + 1);

    return Array.from({ length: stripeCount }).map((_, i) => {
      const stripePosition = startPos + gapSize * (i + 1);
      
      // Create a belt object for this black belt stripe
      const stripeBelt: Belt = {
        name: `Black belt ${i + 1} stripe${i === 0 ? '' : 's'}`,
        color: '#000000',
        dbColor: 'black',
        stripes: i + 1,
        isStripe: true
      };

      return (
        <div 
          key={`blackbelt-stripe-${i}`}
          className="absolute transform -translate-x-1/2 z-10 cursor-pointer hover:scale-110 hover:brightness-95 transition-all"
          style={{ 
            left: stripePosition, 
            top: '50%',
            transform: 'translate(-50%, -50%)',
            height: '56px',
            width: '16px',
            backgroundColor: 'white',
            border: '2px solid black',
            borderRadius: '4px'
          }}
          onClick={() => onStripeClick && onStripeClick(stripeBelt)}
          role="button"
          tabIndex={0}
          aria-label={`Black belt ${i + 1} stripe${i === 0 ? '' : 's'}`}
        />
      );
    });
  };

  return (
    <>
      {renderStripesBetweenBelts()}
      {renderStripesAfterBlackBelt()}
    </>
  );
};